/**
 * CollapsibleCard Component
 *
 * Card wrapper with collapsible content
 */

import React from 'react';
import { Card, CardContent, Collapse, Box } from '@mui/material';
import SectionHeader, { SectionHeaderProps } from './SectionHeader';

export interface CollapsibleCardProps extends Omit<SectionHeaderProps, 'expanded' | 'onToggle'> {
    expanded: boolean;
    onToggle: () => void;
    children: React.ReactNode;
    noPadding?: boolean;
    sx?: object;
}

export const CollapsibleCard: React.FC<CollapsibleCardProps> = ({
    expanded,
    onToggle,
    children,
    noPadding = false,
    sx = {},
    isDarkMode,
    ...headerProps
}) => {
    return (
        <Card
            sx={{
                mb: 3,
                borderRadius: 3,
                bgcolor: isDarkMode ? '#1e293b' : '#ffffff',
                border: `1px solid ${isDarkMode ? '#334155' : '#e2e8f0'}`,
                boxShadow: isDarkMode
                    ? '0 4px 20px rgba(0,0,0,0.3)'
                    : '0 4px 20px rgba(0,0,0,0.05)',
                overflow: 'hidden',
                ...sx,
            }}
        >
            <CardContent sx={{ p: 3, '&:last-child': { pb: 3 } }}>
                <SectionHeader
                    {...headerProps}
                    expanded={expanded}
                    onToggle={onToggle}
                    isDarkMode={isDarkMode}
                />
                <Collapse in={expanded}>
                    <Box sx={{ mt: 2, ...(noPadding ? { mx: -3, mb: -3 } : {}) }}>
                        {children}
                    </Box>
                </Collapse>
            </CardContent>
        </Card>
    );
};

export default CollapsibleCard;
